import TreeCheckboxDropdown from './TreeCheckboxDropdown.vue';

export default {
  install(Vue) {
    Vue.component('tree-checkbox-dropdown', TreeCheckboxDropdown);
  },
};
